/* Botenor : fiche produit v3 (comportements propres à la refonte) */
(function () {
  /* 1. Cercles des résultats visibles : animation en boucle dès qu'ils sont visibles */
  function initResults() {
    var items = document.querySelectorAll('.product-v3 .product-results__item');
    if (!items.length) return;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var DURATION = 1200, HOLD = 3600, PAUSE = 500;
    var loops = [];
    items.forEach(function (item) {
      item.classList.add('is-animated');
      var number = item.querySelector('.product-results__number');
      var circle = item.querySelector('.product-results__circle');
      var label = item.querySelector('.product-results__text');
      if (!number || !circle) return;
      var target = parseInt(item.dataset.resultPercent, 10) || 0;
      var perceived = label && label.textContent.indexOf('**') !== -1;
      var prefix = perceived ? '' : (number.dataset.prefix || '');
      var raf = null, timer = null, running = false;
      function paint(v) { circle.style.setProperty('--progress', v); number.textContent = prefix + v + '%'; }
      function play() {
        if (!running) return;
        var start = performance.now();
        function frame(t) {
          if (!running) return;
          var p = Math.min((t - start) / DURATION, 1);
          paint(Math.round(target * (1 - Math.pow(1 - p, 3))));
          if (p < 1) { raf = requestAnimationFrame(frame); }
          else { timer = setTimeout(function () { paint(0); timer = setTimeout(play, PAUSE); }, HOLD); }
        }
        raf = requestAnimationFrame(frame);
      }
      function startLoop() { if (running) return; running = true; if (reduce) { paint(target); return; } play(); }
      function stopLoop() { running = false; cancelAnimationFrame(raf); clearTimeout(timer); paint(target); }
      paint(0);
      loops.push({ item: item, start: startLoop, stop: stopLoop });
    });
    if (!('IntersectionObserver' in window)) { loops.forEach(function (l) { l.start(); }); return; }
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        loops.forEach(function (l) {
          if (l.item === entry.target) { if (entry.isIntersecting) { l.start(); } else { l.stop(); } }
        });
      });
    }, { threshold: 0.2 });
    loops.forEach(function (l) { observer.observe(l.item); });
  }

  /* 2. Lignes d'information : pas de trait séparateur orphelin en fin de ligne */
  function markRows() {
    var lists = document.querySelectorAll('.product-v3 .product-highlights');
    lists.forEach(function (list) {
      var items = Array.prototype.slice.call(list.querySelectorAll('.product-highlights__item'));
      items.forEach(function (it) { it.classList.remove('is-row-end'); });
      items.forEach(function (it, i) {
        var next = items[i + 1];
        if (!next || next.offsetTop > it.offsetTop + 2) { it.classList.add('is-row-end'); }
      });
    });
  }

  /* 3. Lignes sous le format (50 ml) : démarrent exactement à l'aplomb du texte du bouton 50 ml */
  function alignVariantText() {
    var pickers = document.querySelectorAll('.product-v3 variant-picker');
    pickers.forEach(function (vp) {
      var text = vp.querySelector('.variant-picker__variant-text');
      var list = vp.querySelector('.variant-picker__option-values');
      if (!text || !list) return;
      var walker = document.createTreeWalker(list, NodeFilter.SHOW_TEXT, null);
      var node = null, found = null;
      while ((node = walker.nextNode())) {
        if (node.nodeValue && node.nodeValue.trim()) { found = node; break; }
      }
      if (!found) return;
      text.style.paddingLeft = '0px';
      var range = document.createRange();
      range.selectNodeContents(found);
      var textLeft = range.getBoundingClientRect().left;
      var baseLeft = text.getBoundingClientRect().left;
      var offset = textLeft - baseLeft;
      if (offset > 0 && offset < 80) { text.style.paddingLeft = offset + 'px'; }
    });
  }

  /* 4. Section Ingrédients : le texte de droite change au survol de chaque nom (souris, stylet, focus clavier).
        Sur mobile, un appui change le texte et la fiche s'affiche si elle est hors écran. */
  function initIngredientHover() {
    var section = document.querySelector('.product-ingredients');
    if (!section) return;
    var buttons = section.querySelectorAll('[data-ingredient-button]');
    var isMobile = window.matchMedia('(max-width: 768px)');
    buttons.forEach(function (btn) {
      function activate() { if (!btn.classList.contains('is-active')) { btn.click(); } }
      btn.addEventListener('pointerenter', function (e) { if (e.pointerType !== 'touch') { activate(); } });
      btn.addEventListener('mouseenter', activate);
      btn.addEventListener('focus', activate);
      btn.addEventListener('click', function () {
        if (!isMobile.matches) return;
        var card = section.querySelector('.product-ingredients__card.is-active');
        if (!card) return;
        var rect = card.getBoundingClientRect();
        if (rect.top > window.innerHeight * 0.75 || rect.bottom < 0) {
          card.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
      });
    });
  }

  /* 5. Galerie : survoler une vignette de gauche affiche aussitôt la photo ou la vidéo à droite (souris et stylet) */
  function initGalleryHover() {
    var thumbs = document.querySelectorAll('.product-gallery__thumbnail');
    thumbs.forEach(function (btn) {
      btn.addEventListener('pointerenter', function (e) {
        if (e.pointerType === 'touch') return;
        if (btn.getAttribute('aria-current') === 'true') return;
        btn.click();
      });
    });
  }

  /* 6. Bouton « Mot de la fondatrice » : SON ACTIF au clic (le bouton passe en vert, les barres bougent) ; un 2e clic
        passe en SILENCE (le son est coupé, la lecture continue, les barres se figent et sont barrées) ; un 3e clic remet le son.
        Quand la voix est terminée, le prochain clic la relance depuis le début. Le clignotement (4 fois) est géré en CSS
        et s'arrête au clic. Le fichier n'est chargé qu'au premier clic.
        APERÇU : sans fichier audio sur le produit (data-audio-src vide), la lecture est simulée (sans son). */
  function initVoice() {
    var buttons = document.querySelectorAll('[data-botenor-voice]');
    if (!buttons.length) return;
    var src = buttons[0].getAttribute('data-audio-src');
    var audio = null;
    var previewTimer = null;
    var started = false;
    var muted = false;

    function render() {
      buttons.forEach(function (b) {
        b.classList.toggle('is-playing', started && !muted);
        b.classList.toggle('is-muted', started && muted);
        b.setAttribute('aria-pressed', (started && !muted) ? 'true' : 'false');
        b.setAttribute('aria-label', !started ? 'Écouter le mot de la fondatrice' : (muted ? 'Réactiver le son' : 'Couper le son'));
      });
    }
    function markSeen() {
      buttons.forEach(function (b) { b.classList.add('is-seen'); });
    }
    function reset() {
      started = false;
      muted = false;
      render();
    }

    if (!src) {
      buttons.forEach(function (btn) {
        btn.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          markSeen();
          if (!started) { started = true; muted = false; }
          else { muted = !muted; }
          render();
          clearTimeout(previewTimer);
          previewTimer = setTimeout(reset, 12000);
        });
      });
      return;
    }

    function getAudio() {
      if (!audio) {
        audio = new Audio(src);
        audio.preload = 'auto';
        audio.addEventListener('ended', function () { audio.currentTime = 0; reset(); });
      }
      return audio;
    }

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        markSeen();
        var a = getAudio();
        if (!started) {
          a.muted = false;
          muted = false;
          var p = a.play();
          started = true;
          render();
          if (p && p.catch) { p.catch(function () { reset(); }); }
        } else {
          muted = !muted;
          a.muted = muted;
          render();
        }
      });
    });
  }

  /* 7. Renvois d'astérisques (*, **, ***) dans les textes : mis en exposant, plus petits que le texte (classe botenor-ast).
        Les notes de bas de fiche ne sont pas touchées (déjà en petit). */
  function initAsterisks() {
    var roots = document.querySelectorAll('.product-v3 p, .product-v3 .product-benefit__title, .product-v3 .product-benefit__text, .product-v3 .product-results__text');
    roots.forEach(function (el) {
      if (el.closest('.product-notes')) return;
      var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
      var nodes = [], n;
      while ((n = walker.nextNode())) {
        if (n.nodeValue.indexOf('*') === -1) continue;
        if (n.parentNode && n.parentNode.classList && n.parentNode.classList.contains('botenor-ast')) continue;
        nodes.push(n);
      }
      nodes.forEach(function (node) {
        var parts = node.nodeValue.split(/(\*+)/);
        if (parts.length < 2) return;
        var frag = document.createDocumentFragment();
        parts.forEach(function (part) {
          if (!part) return;
          if (/^\*+$/.test(part)) {
            var s = document.createElement('span');
            s.className = 'botenor-ast';
            s.textContent = part;
            frag.appendChild(s);
          } else {
            frag.appendChild(document.createTextNode(part));
          }
        });
        node.parentNode.replaceChild(frag, node);
      });
    });
  }

  function safe(fn) { try { fn(); } catch (e) { if (window.console) { console.warn('botenor-product-v3', e); } } }

  function layout() { safe(markRows); safe(alignVariantText); }

  function init() {
    safe(initIngredientHover);
    safe(initGalleryHover);
    safe(initVoice);
    safe(initResults);
    safe(initAsterisks);
    layout();
    window.addEventListener('resize', layout);
    window.addEventListener('load', layout);
    if (document.fonts && document.fonts.ready) { document.fonts.ready.then(layout); }
  }

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
})();
